import { CLASS_DETAILS_DATA_RETRIEVED } from './class-details-actions';

const defaultState = [];

/**
 * Class Details Reducer
 *
 * Consumes CLASS_DETAILS_DATA_RETRIEVED action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - current list of items to display in class details table
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case CLASS_DETAILS_DATA_RETRIEVED:
        return action.payload;
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/class-details/class-details-reducer.js